/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'MACHINERY_AND_EQUIPMENT_HAVE_A_FUNCTIONING_LOCKOUT_TAGOUT_PROGR',
              'WORKER_MACHINERY_AND_EQUIPMENT_TRAINING_RECORDS_ARE_MAINTAINED_',
              'MACHINERY_AND_EQUIPMENT_HAVE_SAFETY_INSTRUCTIONS_DISPLAYED_OR_P',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_of_the_following_safety_measures_in_place_11: valueSchema,
  },
}
